import React from 'react';
import { useDropdown } from '@hooks/useDropdown';
import { Arrow } from '@icons/common';
import { ListItem } from '@components/ListItem';
import { ProductModelItem } from '@layouts/Related/Related.types';
import './ProductSelector.scss';

interface ProductSelectorProps {
  selectedProduct: string;
  onSelectProduct: (product: ProductModelItem) => void;
  products: ProductModelItem[];
}

export const ProductSelector = ({
  selectedProduct,
  products,
  onSelectProduct,
}: ProductSelectorProps) => {
  const { isOpen, DropdownWrapper, onOpen } = useDropdown(
    products.map((product) => (
      <ListItem
        key={product.ProductModelId}
        title={product.ProductModelDisplayName}
        active={selectedProduct === product.ProductModelDisplayName}
        action={() => onSelectProduct(product)}
      />
    ))
  );

  if (!products || products.length < 2) {
    return (
      <div className='technical-details-title technical-details-title--no-selection'>
        <h2>{selectedProduct}</h2>
      </div>
    );
  }

  return (
    <DropdownWrapper>
      <div className='technical-details-title' onClick={onOpen}>
        <h2>{selectedProduct}</h2>
        <Arrow rotate={isOpen ? 90 : 270} />
      </div>
    </DropdownWrapper>
  );
};
